/**
 * 资源路径帮助函数
 * 用于在应用中引用src/assets目录下的资源
 * 
 * 使用方式:
 * 1. 直接导入图片: import logo from '../assets/images/logo.png';
 * 2. 使用辅助函数(当路径需要动态构建时): getImageUrl('logo.png')
 */

// 导入常用的图片资源用于动态引用
// 二维码图片
import officialQrCode from '../assets/images/qr/official.jpg';
import wechatQrCode from '../assets/images/qr/wechat.jpg';

// 其他常用图片
import consciousImage from '../assets/images/conscious1.jpeg';
import iceImage from '../assets/images/ice.png';

// 公司logo图片 - 动态导入所有公司logo
export const companyLogos = {};

// 使用require.context动态导入company目录下的所有图片(如果支持的话)
// 注意: 在某些环境中可能需要额外配置
function importAll(r) {
  r.keys().forEach(key => {
    // 提取文件名 (例如: './Frame 2066.png' -> 'Frame 2066.png')
    const fileName = key.replace('./', '');
    companyLogos[fileName] = r(key);
  });
}

// 尝试使用require.context，如果不支持则捕获错误
try {
  // 这会在webpack环境中工作，但可能需要在craco.config.js中配置
  const req = require.context('../assets/images/companys', false, /\.(png|jpe?g|svg)$/);
  importAll(req);
} catch (error) {
  console.warn('无法动态导入公司logo，将使用按需导入');
  
  // 手动导入公司logo
  // 这里可以根据需要添加更多
  import('../assets/images/companys/Frame 2066.png').then(module => { companyLogos['Frame 2066.png'] = module.default; });
  import('../assets/images/companys/Frame 2067.png').then(module => { companyLogos['Frame 2067.png'] = module.default; });
  import('../assets/images/companys/Frame 2068.png').then(module => { companyLogos['Frame 2068.png'] = module.default; });
  // ... 其他可以根据需要添加
}

// 资源映射对象
const resourceMap = {
  // 二维码资源
  'images/qr/official.jpg': officialQrCode,
  'images/qr/wechat.jpg': wechatQrCode,
  
  // 其他图片资源
  'images/conscious.jpeg': consciousImage,
  'images/ice.png': iceImage,
};

/**
 * 获取资源URL - 支持动态路径
 * 注意: 对于动态路径，资源必须预先导入到resourceMap中
 */
export function getAssetUrl(relativePath) {
  if (resourceMap[relativePath]) {
    return resourceMap[relativePath];
  }
  
  // 如果资源不在映射表中，给出警告
  console.warn(`资源 "${relativePath}" 未在resourceMap中预定义，可能无法正确加载`);
  return ''; // 返回空字符串，避免请求错误路径
}

/**
 * 获取图片资源URL
 */
export function getImageUrl(imageName) {
  return getAssetUrl(`images/${imageName}`);
}

/**
 * 获取公司logo的URL
 */
export function getCompanyLogoUrl(logoName) {
  // 优先从动态导入的映射中获取
  if (companyLogos[logoName]) {
    return companyLogos[logoName];
  }
  
  // 回退使用常规方法
  return getAssetUrl(`images/companys/${logoName}`);
}

/**
 * 获取二维码图片URL
 */
export function getQrCodeUrl(qrName) {
  return getAssetUrl(`images/qr/${qrName}`);
}

// 导出常用图片资源，便于直接导入
export const images = {
  qrCodes: {
    official: officialQrCode,
    wechat: wechatQrCode
  },
  conscious: consciousImage,
  ice: iceImage

};

// 默认导出所有的帮助函数
const assetHelpers = {
  getAssetUrl,
  getImageUrl,
  getCompanyLogoUrl,
  getQrCodeUrl,
  images,
  companyLogos
};

export default assetHelpers; 